import parse from "../parse";
import { CoursePacingsClass } from "../../constants/classes";

export default async function getCoursePacings() {
  const coursePacings = parse.Object.extend(CoursePacingsClass);
  const query = new parse.Query(coursePacings);
  return await query.find();
}
